import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CsvUtilsService {
  public static delimiter = ',';

  public parse(data: string, delimiter = CsvUtilsService.delimiter): Array<Array<string>> {
    const delimitersPattern = `(\\${delimiter}|\\r?\\n|\\r|^)`;
    const quotedFieldsPattern = '(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|';
    const standardFieldsPattern = `([^\"\\${delimiter}\\r\\n]*))`;
    const objPattern = new RegExp(delimitersPattern + quotedFieldsPattern + standardFieldsPattern, 'gi');
    const arrData: Array<Array<string>> = [[]];
    let arrMatches = null;

    while (arrMatches = objPattern.exec(data)) {
      const strMatchedDelimiter = arrMatches[1];

      if (strMatchedDelimiter.length && strMatchedDelimiter !== delimiter) {
        arrData.push([]);
      }

      let strMatchedValue;

      if (arrMatches[2]) {
        strMatchedValue = arrMatches[2].replace(new RegExp( '\"\"', 'g'), '\"');
      } else {
        // We found a non-quoted value.
        strMatchedValue = arrMatches[3];
      }

      arrData[arrData.length - 1].push(strMatchedValue);
    }

    return arrData;
  }

  public generate(headers: Array<string>, data: Array<{ [key: string]: string }>): string {
    let csvRows = [];
    const values = data.map(item => headers.map(key => `"${item[key]}"`).join(','));

    csvRows.push(headers.join(','));
    csvRows = [
      ...csvRows,
      ...values,
    ];

    return csvRows.join('\n');
  }
}
